module.exports = __webpack_public_path__ + "img/icon_radar.126db066.svg";